export const SET_DEPOSIT = 'SET_DEPOSIT';

export const setDeposit = (deposit) => ({
  type: SET_DEPOSIT,
  deposit: deposit,
});
